export const bulletin_info = [
  // Test comment

  // {
  //     id:'17',
  //     link:"https://drive.google.com/file/d/1_aHOLV5dNjT2yAjPmTETJ6xh83GbjILm/view?usp=sharing",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">Temporary Assistant Professor recruitment process update</span>
  //         </span>
  //     ),
  // },
  // {
  //     id:'18',
  //     link:"https://drive.google.com/file/d/17RX_8RPOO-iiaYEauYChQ4IWnT9BYude/view?usp=drive_link",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">Written & Interview - Notification of Temporary Assistant Professors</span>
  //         </span>
  //     ),
  // },
  //     {
  //         id:'18',
  //         link:"https://drive.google.com/file/d/1c2uJ7w2EEFF2eGogbvEeb7or1inLqAmp/view?usp=sharing",
  //         content:(
  //             <span>
  //                 <span className="newContent">New</span> <span className="insideNewContent">Advertisement for Recruitment of Junior Research Fellow under DST-SERB-SURE Research Project
  // </span>
  //             </span>
  //         ),
  //     },
  // {
  //     id:'43',
  //     link:"https://drive.google.com/file/d/11D-BId2jPMxxgzqjYvhOEfOCKuYuT3a2/view?usp=drivesdk",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">SDG Club - Short Video Contest on Earth day 22-04-2025</span>
  //         </span>
  //     ),
  // },

  // {
  //   id: "58",
  //   link: "https://drive.google.com/file/d/1i010htK--L6CFXkyVRp0tt-br9GLzVQp/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //       ACGCET & ACCETOSA Organizes Two days Induction Program - 15th,16th - July 2025
  //       </span>
  //     </span>
  //   ),
  // },

  {
    id: "87",
    link: "https://drive.google.com/file/d/1EPLDzIcEStoM_fxd4Z8zdeIxcIJCY4WN/view?usp=sharing",
    content: (
       <span>
        <span className="newContent">New</span>{" "}
        <span className="insideNewContent">{" "} PART TIME AND WORKING PROFESSIONALS TIME TABLE - MAY 2026 AUTONOMOUS EXAMINATIONS
            </span>
            </span>
    ),
  },
 

  {
    id: "86",
    link: "https://drive.google.com/file/d/19y-FHoEUU0mD-S-RItDJeYcwfJkIxvkS/view?usp=sharing",
    content: (
       <span>
        <span className="newContent">New</span>{" "}
        <span className="insideNewContent">{" "} BE REGULAR TIME TABLE - MAY 2026 AUTONOMOUS EXAMINATIONS
            </span>
            </span>
    ),
  },
  {
    id: "85",
    link: "https://drive.google.com/file/d/1YdSn2ZMovB2C30fUCQP-jyzDkjCbEyre/view?usp=sharing",
    content: (
       <span>
        <span className="newContent">New</span>{" "}
        <span className="insideNewContent">{" "} ME TIME TABLE - MAY 2026 AUTONOMOUS EXAMINATIONS
            </span>
            </span>
    ),
  },
  {
    id: "84",
    link: "https://drive.google.com/file/d/1N_7t6KPC0a1yGrnWTlw86hFlcNA7ZJ7u/view?usp=sharing",
    content: (
       <span>
        <span className="newContent">New</span>{" "}
        <span className="insideNewContent">{" "} BE & ME ARREAR TIME TABLE - MAY 2026 AUTONOMOUS EXAMINATIONS
            </span>
            </span>
    ),
  },
  
  ,
  { id: "82",
    link: "https://drive.google.com/file/d/1_bawT9NXyU1cS2gXdzmPGS5lYA5rr65w/view?usp=sharing",
    content: (
      <span>
        <span className="newContent">New</span>{" "}
        <span className="insideNewContent">{" "}  RULES AND REGULATION FOR STUDENTS 2026
        </span>
      </span>
    ),
  },
  //{ id: "81",
  //  link: "https://drive.google.com/file/d/1GJ5AcXuki9plETXvOQqi6HPOo0aLK1if/view?usp=drive_link",
   // content: (
   //   <span>
    //    <span className="newContent">New</span>{" "}
    //    <span className="insideNewContent">{" "}AICTE IDEA LAB - TENDER NOTICE WITH TECHNICAL SPECIFICATIONS
     //   </span>
     // </span>
    //),},
 // {
  //  id: "80",
  //  link: "https://drive.google.com/file/d/1hXBSnv9SG1yuUM7vWEj3OXoVGC7fAXkb/view?usp=sharing",
   // content: (
    //  <span>
     //   <span className="newContent">New</span>{" "}
      //  <span className="insideNewContent">{" "}APPLICATION FOR REVALUATION/ OF ANSWER SCRIPT – NOV/DEC 2025
      //  </span>
      //</span>
   // ),
  //},
  //{
   // id: "79",
    //link: "https://drive.google.com/file/d/1jcnMCyxWVXELF5BJb8XBFkgM2sETgc3h/view?usp=sharing",
    //content: (
     // <span>
      //  <span className="newContent">New</span>{" "}
      //  <span className="insideNewContent">{" "}
       //   RECRUITMENT OF ASSISTANT PROFESSOR ON CONTRACT BASIS TO ECE DEPARTMENT
       // </span>
     // </span>
    //),
 // },
 // {
  //  id: "78",
  //  link: "https://drive.google.com/file/d/12-kpgfPEA3w7aje1iMpQG_Dx3yvPlFEq/view?usp=sharing",
   // content: (
   //   <span>
    //    {/* <span className="newContent">New</span>{" "} */}
     //   <span className="insideNewContent">{" "}
     //     RE-ADMISSION CIRCULAR-AY 2025-2026
      //  </span>
     // </span>
   // ),
  //},
  {
    id: "77",
    link: "https://drive.google.com/file/d/1Op-zeS0j6U_CrYFk5iLl_jChn30UN2MI/view?usp=sharing",
    content: (
      <span>
        {/* <span className="newContent">New</span>{" "} */}
        <span className="insideNewContent">{" "}
          ACADEMIC CALENDAR FOR THE  AY 2025-26 (EVEN SEM)
        </span>
      </span>
    ),
  },
 // {
  //  id: "76",
  //  link: "https://drive.google.com/file/d/1lJRPneH3WZ-dE3Zr2aQm3xkxvB7VgwYA/view?usp=drivesdk",
    //content: (
    //  <span>
    //    {/* <span className="newContent">New</span>{" "} */}
    //    <span className="insideNewContent">{" "}
    //      E- PROCUREMENT TENDER NOTICE- IOT SERVER WITH INTEGRATED GPU MODULES
    //    </span>
     // </span>
   // ),

 // },
  // {
  //   id: "75",
  //   link: "https://drive.google.com/file/d/14geJGbqGX0zEShHiOMLd7JaNnJ_4VsEL/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         BLOOD DONATION CAMP ON 31-10-2025
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "74",
  //   link: "https://drive.google.com/file/d/1AiT2MZm9ffxG9-5sWwFSpHYf5VP_UENu/view?usp=drivesdk ",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         NOV / DEC 2025 AUTONOMOUS EXAMINATIONS TIME TABLE FOR B.E WORKING PROFESSIONALS -  (I SEMESTER)
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "73",
  //   link: "https://drive.google.com/file/d/1qIlfTWYVt4rjNhKr9mpZ3gb7NVwUY73G/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         NOV / DEC 2025 AUTONOMOUS EXAMINATIONS - REVISED TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "72",
  //   link: "https://drive.google.com/file/d/1LRyDMmRGqh2L1vgqq00KyP_3ngWZ_kWb/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         BE REGULAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "73",
  //   link: "https://drive.google.com/file/d/1JpKzfSqRT33miWpFHxYFYnf1k1Zt7no6/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         BE & PTBE- R2022 ARREAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "74",
  //   link: "https://drive.google.com/file/d/13xgdjQXfk2lVowoP_aHo1SLDbiPnVbX1/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         PTBE REGULAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "75",
  //   link: "https://drive.google.com/file/d/1GxktLes9CDJgDhXSbVQF6MbGN_k5kH7t/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         ME REGULAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "76",
  //   link: "https://drive.google.com/file/d/1KW9pqDV3kaqK8i1tl4O7wjPho_cOnEtL/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         BE & PTBE- R2019 & 2019A ARREAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "77",
  //   link: "https://drive.google.com/file/d/1gssAKbVDkbjn6DoZnxi29P3K3np-U1o0/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         Ph.D Coursework  - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "78",
  //   link: "https://drive.google.com/file/d/1aPJ7p0dDWf-OWoFBe78iTUzJ2GBIZPjO/view?usp=sharing",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         ME- R2022 ARREAR - NOV DEC 2025 AUTONOMOUS EXAMS TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "71",
  //   link: "https://drive.google.com/file/d/1-25_Kx48EyavC5O-alCEDVllcfI5mcKQ/view?usp=drivesdk ",
  //   content: (
  //     <span>
  //       {/* <span className="newContent">New</span>{" "} */}
  //       <span className="insideNewContent">{" "}
  //         Revised Academic Calendar for the  AY 2025-26 (Odd Sem)
  //       </span>
  //     </span>
  //   ),
  // },
  //  {
  //   id: "70",
  //   link: "https://drive.google.com/file/d/1ZQWCNsGCIIl8NoOYJkLWVrI_SlW75vy8/view?usp=drivesdk  ",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //         Foreign Language - Self Learning Course Registration - Circular 
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "69",
  //   link: "https://drive.google.com/drive/folders/1TWmsDIaj0un4gJNj64ieb1eaVlDdTvAy?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //         Awareness video link for "Ban on single use Plastics"
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "68",
  //   link: "https://drive.google.com/file/d/1u3MzomsHadBGkhAnjs3x9jlPvBDaOHhW/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //         First year M.E. Classes commences on 15.09.2025 (AY 2025–2026)
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "67",
  //   link: "https://drive.google.com/file/d/1q7A8s-hb1RpM2Y7Ca-9dcyo0knGVP4Ry/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        First year Part Time B.E. Classes commences on 15.09.2025 (AY 2025–2026)
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "66",
  //   link: "https://drive.google.com/file/d/1LR0TgClWgZGw0coJGpp6x50aAkqgKtqG/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Revised Academic Calendar for the  AY 2025-26 (Odd Sem)
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "65",
  //   link: "https://drive.google.com/file/d/1VqbfdrHQH1bqEoF2BSQE3iObaT9o1xLj/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Advertisement for the Post of 'Project Assistant' under CMRG Project
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "64",
  //   link: "https://drive.google.com/file/d/13HnZRkYP9nVJ7QmI6KbBEMdoyy1EwcK_/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Application for the Post of 'Project Assistant' under CMRG Project
  //       </span>
  //     </span>
  //   ),
  // },

  //    {
  //   id: "62",
  //   link: "https://drive.google.com/file/d/1G6sxg-gktItWfLh9cs9IPQSThVj4rz5M/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        First year B.E., /B.Tech., Classes commences on 11.08.2025 click here for more details. ( முதலாம் ஆண்டு B.E., /B.Tech., வகுப்புகள் 11.08.2025 அன்று துவங்கப்பட உள்ளது. மேலும் விவரங்களுக்கு இங்கே சொடுக்கவும் )
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "63",
  //   link: "https://drive.google.com/file/d/1MLlimfSjLBHTIV_UPE7Rre5CkyCJ1UMZ/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent"></span>{" "}
  //       <span className="insideNewContent">{" "}
  //       ME Degree I Year - Fees Details AY 2025-2026
  //       </span>
  //     </span>
  //   ),
  // },
  //    {
  //   id: "61",
  //   link: "https://drive.google.com/file/d/157-LjeW4r67Rh8jpTwIEGqmV5Q133g2y/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        First Year & Part-time BE - AY 2025-2026 - Intimation to Report College
  //       </span>
  //     </span>
  //   ),
  // },
  {
    id: "60",
    link: "https://drive.google.com/file/d/1aZqv5Ery4RGIgSyjcNCyNWOjPnwLf1kz/view?usp=sharing",
    content: (
      <span>
        <span className="newContent"></span>{" "}
        <span className="insideNewContent">{" "}
          PRAGATI SCHOLARSHIP AY 2025-2026 - CIRCULAR
        </span>
      </span>
    ),
  },
  //  {
  //   id: "59",
  //   link: "https://drive.google.com/file/d/1yzmyNx9QCEtklA0tyhkTvSnyBlftYvdp/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        College Fees with fine amount for AY 2025-2026 - Circular
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "57",
  //   link: "https://drive.google.com/file/d/18J5Z7_2mDM6oIBhTL5-odx7tjOATvCHJ/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //       Lateral Entry (Direct 2nd year) B.E Degree Course AY 2025 - 2026 Fee Details - Circular
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "56",
  //   link: "https://drive.google.com/file/d/19NUSEsDj8wDgaubG7ZUvdsTrc8WpKY2Y/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Application for Revaluation of Answer script – APRIL/MAY 2025
  //       </span>
  //     </span>
  //   ),
  // },
  //  {
  //   id: "55",
  //   link: "https://drive.google.com/file/d/1imFUAe_GE9uW2SrzQoDLDa7dkWzOb_2K/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Full Time B.E Degree Courses AY 2025-2026 (I semester) Fee Structure Details - Circular
  //       </span>
  //     </span>
  //   ),
  // },

  // {
  //   id: "54",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        Classes for III, V, and VIII semester B.E. (Full-Time & Part-Time) and III semester M.E. are scheduled to commence on 07.07.2025.
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "53",
  //   link: "https://drive.google.com/file/d/1pE7CTJ5aPtlTiXoWJvYvnI5BTopqCMfa/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">{" "}
  //        College Fee for the AY 2025-2026 - Circular
  //       </span>
  //     </span>
  //   ),
  // },

  // {
  //   id: "51",
  //   link: "https://drive.google.com/file/d/1KyRF0ANFRNT_smChb4ZyBqrZ8rLGQcN9/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         {" "}
  //         Recruiting Assistant Professor(Contract Basis) in Civil Engineering
  //         Department
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "50",
  //   link: "https://drive.google.com/file/d/1Qz0_PYTkcHl62NM1rqOmP0ZAZRhx0N9y/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         {" "}
  //         Best All Round Outgoing student Award 2025 - Circular & Application{" "}
  //       </span>
  //     </span>
  //   ),
  // },

  // {
  //   id: "50",
  //   link: "https://drive.google.com/file/d/1EZqMphFausTzPEaldv7Qth1KwNR0KmH9/view?usp=drivesdk",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         {" "}
  //         Recruiting Assistant Professor (Contract basis) in ECE department{" "}
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "49",
  //   link: "https://drive.google.com/file/d/11WysoDA_X-lglXOCPhEc2V7D3oxFM50m/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         Recruitment of Manager and Associate for Alagappa Incubation Council -
  //         Last date extended upto 12/05/2025
  //       </span>
  //     </span>
  //   ),
  // },

  // {
  //   id: "42",
  //   link: "https://drive.google.com/file/d/1gvba4tKiGOVo60K9zUMUk1VBzsUf-YSR/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - B.E. REGULAR
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "41",
  //   link: "https://drive.google.com/file/d/1gsJCOCxeWsDBHuBd1hjLKtIQOFm44ys6/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - P.T.B.E. REGULAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "40",
  //   link: "https://drive.google.com/file/d/1gqd6xzVAU8M6f_nXxU4YBHGkMIT19q63/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - M.E. REGULAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "43",
  //   link: "https://drive.google.com/file/d/1gpRQWkZMVfor2Fih3pxF_u-dozq3A6rE/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - M.E. REGULAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "44",
  //   link: "https://drive.google.com/file/d/1l4E6n3498A_PwFRqx4guGTkEZWxSayZ4/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - B.E. & P.T.B.E. R2022 ARREAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "45",
  //   link: "https://drive.google.com/file/d/1gk9cqAVTNIHZtZOylo40WRbyO9nONw89/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - B.E. & P.T.B.E. R2019 & 2019A ARREAR
  //         TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "46",
  //   link: "https://drive.google.com/file/d/1aOCnNphpVTQlfg2xqb2mSDDMXMG-0YiW/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - M.E. ARREAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //   id: "47",
  //   link: "https://drive.google.com/file/d/1gY5mCmrivY26KOjGqR3Cb35v7ai-Xxbf/view?usp=drive_link",
  //   content: (
  //     <span>
  //       <span className="newContent">New</span>{" "}
  //       <span className="insideNewContent">
  //         APR MAY 2025 AUTONOMOUS EXAM - B.E. SPECIAL ARREAR TIMETABLE
  //       </span>
  //     </span>
  //   ),
  // },
  // {
  //     id:'39',
  //     link:"https://drive.google.com/file/d/1qPiH9ENVvH9vGG0ktx42Qk3e_VtHh8F0/view?usp=sharing",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">Graduation day Invitation</span>
  //         </span>
  //     ),
  // },
  // {
  //   id: "38",
  //   link: "https://drive.google.com/file/d/1nyf7TuHNab1IO5mOoukhaCW0N5SC-WZe/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent"></span>{" "}
  //       <span className="insideNewContent">
  //         {" "}
  //         ACGCET- HOSTELS- DAILY WAGES- NOTIFICATION 2025
  //       </span>
  //     </span>
  //   ),
  // },

  // {
  //     id:'38',
  //     link:"https://drive.google.com/file/d/1nyf7TuHNab1IO5mOoukhaCW0N5SC-WZe/view?usp=sharing",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent"> ACGCET- HOSTELS- DAILY WAGES- NOTIFICATION 2025
  // </span>
  //         </span>
  //     ),
  // },

  //   {
  //     id: "37",
  //     link: "https://drive.google.com/file/d/1GD-7vdI-WunalCAbigWifaJ0DRQ1FSb4/view?usp=drive_link",
  //     content: (
  //       <span>
  //         <span className="newContent"></span>{" "}
  //         <span className="insideNewContent">
  //           Academic Calendar for the AY 2024-25 (EVEN SEM)
  //         </span>
  //       </span>
  //     ),
  //   },

  // {
  //     id:'36',
  //     link:"https://drive.google.com/file/d/1bHSMio32D7zvniGh4KpJ1q3QdaCXAFL_/view?usp=drive_link",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">Re-addmission for the  AY 2024-25- Circular
  // </span>
  //         </span>
  //     ),
  // },
  // {
  //     id:'35',
  //     link:"https://drive.google.com/file/d/1JcUpA5aUeEwsC9DLbAH223ra40NPtPVm/view?usp=sharing",
  //     content:(
  //         <span>
  //             <span className="newContent">New</span> <span className="insideNewContent">BE Part-time - College Fee for AY 2024-25 - Circular
  // </span>
  //         </span>
  //     ),
  // },
  // {
  //   id: "34",
  //   link: "https://drive.google.com/file/d/11WysoDA_X-lglXOCPhEc2V7D3oxFM50m/view?usp=sharing",
  //   content: (
  //     <span>
  //       <span className="newContent"></span>{" "}
  //       <span className="insideNewContent">
  //         Establishment of StartupTN Pre-incubation Centre
  //       </span>
  //     </span>
  //   ),
  // },
  {
    id: "13",
    link: "https://drive.google.com/file/d/1Yqep4TBUBHSDrIxzLoqGV-Pp5UdWMTHI/view",
    content: "GUIDELINES FOR SC ST SCHOLARSHIP APPLICATION",
  }
];
